import ReactGA from 'react-ga4';

// Firebase Konfiguration
export const firebaseConfig = {
  apiKey: "AIzaSyD72yD-OshcMFWcVA1vldInaPd0BnoNb0Y",
  authDomain: "mvs-rechner.firebaseapp.com",
  databaseURL: "https://mvs-rechner-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "mvs-rechner",
  storageBucket: "mvs-rechner.firebasestorage.app",
  messagingSenderId: "507686546622",
  appId: "1:507686546622:web:9abfcb965950b7213742ef",
  measurementId: "G-K8W9MHPS35"
};

// Google Analytics Measurement ID
const MEASUREMENT_ID = 'G-K8W9MHPS35'; // Aus der Firebase-Konfiguration

interface TrackingOptions {
  anonymizeIp?: boolean;
  cookieExpires?: number;
}

// Analytics initialisieren
export function initGA(
  measurementId: string = MEASUREMENT_ID, 
  options: TrackingOptions = { anonymizeIp: true }
) {
  ReactGA.initialize(measurementId, {
    gaOptions: {
      cookieExpires: options.cookieExpires || 2592000, // 30 Tage in Sekunden
    },
    gtagOptions: {
      anonymize_ip: options.anonymizeIp
    }
  });
  
  console.log('Google Analytics initialisiert mit ID:', measurementId);
}

// Seitenaufruf tracken
export function trackPageView(path?: string) {
  const page = path || window.location.pathname + window.location.search;
  ReactGA.send({ hitType: 'pageview', page });
  console.log('Seitenaufruf getrackt:', page);
}

// Conversion-Event tracken
export function trackCalculation(resultType: string, fahrzeugTyp: string) {
  ReactGA.event({
    category: 'MVS-Berechnung',
    action: 'Berechnung durchgeführt',
    label: `${fahrzeugTyp} - ${resultType}`
  });
}

// Share-Events tracken
export function trackShare(method: string) {
  ReactGA.event({
    category: 'Teilen',
    action: 'Link geteilt',
    label: method
  });
}

// Feedback-Events tracken
export function trackFeedback(isPositive: boolean) {
  ReactGA.event({
    category: 'Feedback',
    action: 'Feedback gegeben',
    label: isPositive ? 'Positiv' : 'Negativ'
  });
}

// FormField-Events tracken
export function trackFormField(fieldName: string, value: string | number) {
  ReactGA.event({
    category: 'Formular',
    action: 'Feld ausgefüllt',
    label: fieldName,
    // nur numerische Werte als value senden
    value: typeof value === 'number' ? value : undefined
  });
}

// Cookie-Consent setzen
export function setConsent(granted: boolean) {
  ReactGA.gtag('consent', 'update', {
    analytics_storage: granted ? 'granted' : 'denied'
  });
}

// Standard-Exports
export default {
  initGA,
  trackPageView,
  trackCalculation,
  trackShare,
  trackFeedback,
  trackFormField,
  setConsent
}; 
